import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c55c6c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge"
}
const _hoisted_2 = { class: "badge-item" }
const _hoisted_3 = {
  key: 1,
  class: "d-badge"
}
const _hoisted_4 = { class: "d-badge__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showBadge && _ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.number), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showBadge && !_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.number), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}